/**
 * Detects if the app is running as a PWA (in standalone mode)
 * @returns {boolean | undefined} true if PWA, false if not, undefined if can't determine (SSR)
 */
export default function useCheckPWA(): boolean | undefined {
  if (typeof window === 'undefined' || !window.navigator) {
    return undefined;
  }

  // Type assertion for iOS-specific property
  const navigator = window.navigator as Navigator & {
    standalone?: boolean;
  };

  const isStandalone = navigator.standalone || window.matchMedia('(display-mode: standalone)').matches;

  const pwaState = useState<boolean>('isPWA');
  pwaState.value = !!isStandalone;

  return !!isStandalone;
}
